<script setup lang="ts">
  import { computed, ref, watch, defineProps, defineEmits, nextTick  } from 'vue';
  import { useI18n } from '@/hooks/web/useI18n';
  import { COMMON_OPTIONS } from '@/utils/options'
  
  const { t } = useI18n()
  const props = defineProps({
    modelValue: { type:[String,Number] },
    type: { type:String, default:'left' },
    numFlag: { type:Boolean, default:false }
  })
  const _value = ref<any>()
  const _positionType = ref('none')
  const _options = ref({
    positionType:[
      // { value:'none', label:'-'},
      { value:'relative', label:'相对'},
      { value:'absolute', label:'绝对'},
    ],
    leftAlign:[
      { value:'left', label:'居左'},
      { value:'center', label:'居中'},
      { value:'right', label:'居右'}
    ],
    topAlign:[
      { value:'top', label:'上'},
      { value:'middle', label:'中间'},
      { value:'bottom', label:'下'}
    ]         
  })
  const onChangeType = (val)=>{
    if(val == 'none'){
      _value.value = props.type=='left'? 'center':'middle'
    }else if(val == 'relative'){
      _value.value = '0%'
    }else if(val == 'absolute'){
      _value.value = 0
    }
    emit('update:modelValue', _value.value)
  }
  const onChange = (val)=>{
    emit('update:modelValue', _value.value)
  }

  const emit = defineEmits(['update:modelValue']);
  watch(()=>props.modelValue, (val:any) => {
    try{
      if(val != null && val !== ''){
        if(!isNaN(val)){
          _positionType.value = 'absolute'
        }else if(val&&val.includes('%')){
          _positionType.value = 'relative'
        }else{
          _positionType.value = 'none'
        }
        _value.value = val
      }
    }catch(error){}
  }, 
  {
    immediate: true,
    deep: true
  })

</script>

<template>
  <div class="flex gap-[8px]">
    <el-select 
      v-model="_positionType" 
      @change="onChangeType"
      placeholder="" style="width: 60px">
      <el-option v-if="!numFlag" label="-" value="none" />
      <el-option
        v-for="item in _options.positionType"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <div class="flex-1"> 
      <el-select 
        v-if="_positionType=='none'" 
        v-model="_value" @change="onChange"
        placeholder="">
        <template v-if="props.type=='left'">
          <el-option
            v-for="item in _options.leftAlign"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />          
        </template>
        <template v-if="props.type=='top'">
          <el-option
            v-for="item in _options.topAlign"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />          
        </template>
      </el-select>
      <el-input-number 
        v-if="_positionType=='absolute'" 
        v-model="_value" @change="onChange"
        :step="1" controls-position="right" /> 
      <Percentage 
        v-if="_positionType=='relative'" 
        v-model="_value" @change="onChange"
        size="small"/>
    </div>
  </div>
</template>
<style lang="less">
.colors-sel-itm{
  cursor: pointer;
  display: flex;
  align-items: center;
  &>div{
    width: 16px;
    min-height: 16px;
  }   
}
</style>
<style lang="less" scoped>
.colors-sel{
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--bdr-subtle-0_neutral-normal, #C8C8C8);
  background: var(--bg-subtlest-0_neutral-normal, #FFF);
}
</style>